$.fn.m6pressmap = function() {
	return this.each(function() {
		var id = $(this).attr('id'),
			lat = $(this).data('latitude'),
			lng = $(this).data('longitude'),
			marker = $(this).data('marker'),
			info = $(this).data('info');

		if(!id && !lat && !lng)
			return;

		var center = L.latLng(lat, lng);

		var map = L.map(id, {
			center: center,
			zoom: 17,
			zoomControl: false
		});

		var osmTileLayer = L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		});

		map.addLayer( osmTileLayer );
		
		var markerOptions = {};

		if(marker) {
			markerOptions.icon = L.icon({
				iconUrl: marker.src,
				iconSize: JSON.parse(marker.size),
				iconAnchor: JSON.parse(marker.anchor)
			});
		}

		L.control.zoom({
			position: 'bottomright'
		}).addTo(map);

		var marker = L.marker(center, markerOptions).addTo(map);

		if(info) {
			var infoPanel = L.control({
				position: 'topleft'
			});
			infoPanel.onAdd = function (map) {
				this._div = L.DomUtil.create('div', 'map_info'); // create a div with a class "info"
				
				if(info.title)
					this._div.innerHTML += '<div class="map_info_title">' + info.title + '</div>';

				if(info.address)
					this._div.innerHTML += '<div class="map_info_address">' + info.address + '</div>';

				this._div.innerHTML += '<a href="https://www.google.com/maps/dir/?api=1&destination=' + encodeURI(info.title + ' ' + info.address)  + '" target="_blank" class="map_info_navigate">Itinéraires</div>';

				return this._div;
			};
			infoPanel.addTo(map);
		}
	});
};

$('[data-map]').m6pressmap();